var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.95271 12.5009H1.83998C1.24998 12.5009 0.772705 12.0227 0.772705 11.4336V11.0546C0.772705 8.61092 2.75361 6.63092 5.19634 6.63092H6.59634C9.03998 6.63092 11.02 8.61183 11.02 11.0546V11.4336C11.0209 12.0227 10.5427 12.5009 9.95271 12.5009Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89629 5.62364C7.31115 5.62364 8.45811 4.47667 8.45811 3.06182C8.45811 1.64697 7.31115 0.5 5.89629 0.5C4.48144 0.5 3.33447 1.64697 3.33447 3.06182C3.33447 4.47667 4.48144 5.62364 5.89629 5.62364Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4345 5.01911L14.5908 3.86275L13.5336 2.80457L12.3772 3.96093L11.2208 2.80457L10.1636 3.86275L11.3199 5.01911L10.1636 6.17457L11.2208 7.23275L12.3772 6.07638L13.5336 7.23275L14.5908 6.17457L13.4345 5.01911Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveContact);
export default __webpack_public_path__ + "static/media/remove_contact.e05fc0fb4a86d41fec3a7826ee63e926.svg";
export { ForwardRef as ReactComponent };